import { render, staticRenderFns } from "./AppNotificationListWrapper.vue?vue&type=template&id=254eb967&scoped=true&"
import script from "./AppNotificationListWrapper.vue?vue&type=script&lang=js&"
export * from "./AppNotificationListWrapper.vue?vue&type=script&lang=js&"
import style0 from "./AppNotificationListWrapper.vue?vue&type=style&index=0&id=254eb967&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254eb967",
  null
  
)

export default component.exports